// Imports
import { PixelCrop } from 'react-image-crop';


/** Takes in a crop from `react-image-crop` and converts it to a blob */
export default function convertCropToBlob(
	image: HTMLImageElement,
	crop: PixelCrop,
	toBlobParameters: Parameters<HTMLCanvasElement['toBlob']>,
	options?: {
		max?: {
			height: number;
			width: number;
		};
		aspect?: number;
	}
) {
	// Create canvas
	const canvas = document.createElement('canvas');
	
	
	// Get context
	const ctx = canvas.getContext('2d');
	
	if (!ctx) {
		throw new Error('No 2d context');
	}
	
	
	// Calculate scale
	const scaleX = image.naturalWidth / image.width;
	const scaleY = image.naturalHeight / image.height;
	
	
	// Calculate canvas size
	canvas.width = Math.round(crop.width * scaleX);
	canvas.height = Math.round(crop.height * scaleY);
	
	if (options?.aspect) {
		// Set the height relative to the width
		canvas.height = Math.round(canvas.width / options.aspect);
		
		
		// Prevent overflows
		if (canvas.height > image.naturalHeight) {
			canvas.height = image.naturalHeight;
			canvas.width = Math.round(canvas.height * options.aspect);
		}
	}
	
	
	// Calculate crop x and crop y
	const cropX = crop.x * scaleX;
	const cropY = crop.y * scaleY;
	
	
	// Scale image if necessary
	if (options?.max?.width && options?.max.height && canvas.width > options.max.width) {
		canvas.width = options.max.width;
		canvas.height = options.max.height;
		
		const scale = options.max.width / Math.floor(crop.width * scaleX);
		
		ctx.scale(scale, scale);
	}
	
	
	// Draw the image to the canvas
	ctx.drawImage(
		image,
		0,
		0,
		image.naturalWidth,
		image.naturalHeight,
		-cropX,
		-cropY,
		image.naturalWidth,
		image.naturalHeight
	);
	
	
	// Convert to blob
	canvas.toBlob(...toBlobParameters);
}
